export const objectIsEmpty = (obj) => {
  return Object.keys(obj).every(function (key) {
    var val = obj[key];

    if ((Array.isArray(val) && val.length === 0) || (val === '')) {
      return true;
    }

    return false;
  });
}

export const resultsLength = (data) => {
  if (data && data.length > 1) {
    return data.length + ' results';
  } else if (data && data.length === 1) {
    return data.length + ' result'
  } else {
    return '';
  }
}